<div class="contact-content">
    <div class="back-button">
        <mat-icon routerLink="/email">arrow_back</mat-icon>
    </div>
    <h2>{{ 'email.ADD_NEWSLETTER' | translate | uppercase }}</h2>
    <div class="contact-form">
        <div class="form-not-required">
            <form novalidate [formGroup]="newsLetterForm!">
                <div class="field-container-subject">
                    <div class="field-subject">
                        <b>{{ 'email.newsletterTemplateName' | translate }}</b>
                        <div class="data-subject">
                            <input class="form-control" formControlName="templateName" id="subtitle" required type="text" />
                        </div>
                    </div>
                </div>
                <div class="field-container-subject">
                    <div class="field-subject">
                        <b>{{ 'email.newsletterSubject' | translate }}</b>
                        <div class="data-subject">
                            <input class="form-control" formControlName="subject" id="subtitle" required type="text" />
                        </div>
                    </div>
                </div>
            </form>
            <div class="field-container" [ngStyle]="{ 'margin-bottom': '32px' }">
                <div class="field" [ngStyle]="{ padding: '32px' }">
                    <div class="attachment">
                        <div class="attachment-section">
                            <div class="attachment-header">
                                <label>{{ 'email.attachments' | translate }}</label>
                                <small class="hint-text">{{ 'email.filesFromFileManagerAppearsHere' | translate }}</small>
                            </div>

                            <div class="file-grid">
                                @if (fileDataList.length === 0) {
                                    <div class="empty-state">{{ 'email.noAttachmentToNewsletter' | translate }}</div>
                                } @else {
                                    @for (file of fileDataList; track file; let i = $index) {
                                        <div class="file-card">
                                            <div class="file-preview" (click)="openFile(file.url!)">
                                                @if (isImage(file.fileName!)) {
                                                    <img alt="preview" [src]="file.url" />
                                                }
                                                @if (!isImage(file.fileName!)) {
                                                    <mat-icon>insert_drive_file</mat-icon>
                                                }
                                                <div class="overlay">
                                                    <mat-icon>visibility</mat-icon>
                                                </div>
                                            </div>
                                            <div class="file-info">
                                                <div class="name-wrapper">
                                                    <span class="file-name">{{ file.fileName }}</span>
                                                    <div class="full-name">{{ file.fileName }}</div>
                                                </div>
                                                <button color="warn" mat-icon-button type="button" (click)="removeAttachment(file)">
                                                    <mat-icon>delete_forever</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <div class="info">
                        <pf-fileexplorer [attachmentFileDataList]="fileDataList" [attachmentOptionAvailable]="true" />
                    </div>
                    <div class="data">
                        <app-tinymcehtmleditor class="form-control" id="html" ngDefaultControl required type="text" [htmlForm]="htmlForm" />
                        <button type="submit" [disabled]="newsLetterForm!.invalid || htmlForm!.invalid" (click)="addEmailTemplate()">
                            {{ 'email.addNewsletter' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
